import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    getCustomerListInProjectByProjectId,
    getListCustomerUserCanAddToProject
} from '@/service/userService';
import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { Autocomplete } from '@material-ui/lab';
import { I18n } from 'aws-amplify';
import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import CancelEditCustomerList from './dialog/CancelEditCustomerList';
import ConfirmDeleteAdditionUserDialog from './dialog/ConfirmDeleteAdditionUserDialog/ConfirmDeleteAdditionUserDialog';
import {
    filterSugguestionOption,
    addNewRowProjectUser,
    checkDisableBtnSubmit,
    handleSubmit,
    onChangeEmail,
    onChangeNameUser,
    onChangePhoneNumber,
    onChangeOrganizationName,
    onSelectSugguestUser,
    onSubmitCancelEdit,
    reMoveRowProjectUser,
    updateSuggestCustomerUserList,
    onClickCancelEdit,
    isFillUserData,
    isDisableBtnDeleteProjectB2C,
    onClickDeleteProjectB2C,
    isDisplayBtnRestoreB2C,
    handleClickRestoreB2CInProject,
    onSubmitRestoreB2CInProject,
    handleEdit,
    validateEditUser,
    isDisableBtnEditB2C
} from './handler/CustomerListInProjectHandler';
import './CustomerListInProject.css';
import { cloneDeep } from 'lodash';
import { useSnackbar } from 'notistack';
import OverFlowTooltip from '../common/OverFlowTooltip';
import RejectDeleteCustomerUser from './dialog/RejectDeleteCustomerUser';
import ConfirmRestoreUser from '@/component/common/modal/ConfirmRestoreUser';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { clsx } from 'clsx';
import { useRecoilState } from 'recoil';
import { listB2CUserListInOrgAtom } from '@/state/atom/voiceCallAtom';

export default function CustomerListInProject(props) {
    const { projectDetail, corporationId } = props;
    // Noti
    const { enqueueSnackbar } = useSnackbar();
    const [listB2CUserListInOrg, setListB2CUserListInOrg] = useRecoilState(listB2CUserListInOrgAtom);

    const [userAddList, setUserAddList] = useState([]);
    const [isOpenModalConfirmCancel, setIsOpenModalConfirmCancel] = useState(false);
    const [customerListCanAdd, setCustomerListCanAdd] = useState([]);
    const [suggestCustomerUserList, setSuggestCustomerUserList] = useState([]);
    const [defaultSuggestCustomerUserList, setDefaultSuggestCustomerUserList] = useState([]);
    const [isOpenDialogConfirmDelete, setIsOpenDialogConfirmDelete] = useState({
        isEnable: false,
        userId: null
    });
    const [isDisableBtnSubmit, setIsDisableBtnSubmit] = useState(true);
    const [errors, setErrors] = useState({});
    const [triggerReload, setTriggerReload] = useState();
    const [customerList, setCustomerList] = useState([]);
    const [isAddNewUser, setIsAddNewUser] = useState(false);
    const [isOpenModalRejectDeleteUser, setIsOpenModalRejectDeleteUser] = useState(false);
    const [isOpenDialogConfirmRestoreUser, setIsOpenDialogConfirmRestoreUser] = useState(false);
    const [selectedUser, setSelectedUser] = useState({});
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [editUserError, setEditUserError] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const [errorEditUser, setErrorEditUser] = useState({});

    let argsAll = {
        ...props,
        userAddList,
        setUserAddList,
        errors,
        setErrors,
        isOpenModalConfirmCancel,
        setIsOpenModalConfirmCancel,
        customerListCanAdd,
        setCustomerListCanAdd,
        suggestCustomerUserList,
        setSuggestCustomerUserList,
        isDisableBtnSubmit,
        setIsDisableBtnSubmit,
        isOpenDialogConfirmDelete,
        setIsOpenDialogConfirmDelete,
        reMoveRowProjectUser,
        triggerReload,
        setTriggerReload,
        defaultSuggestCustomerUserList,
        setDefaultSuggestCustomerUserList,
        isAddNewUser,
        setIsAddNewUser,
        customerList,
        setCustomerList,
        isOpenModalRejectDeleteUser,
        setIsOpenModalRejectDeleteUser,
        isOpenDialogConfirmRestoreUser,
        setIsOpenDialogConfirmRestoreUser,
        selectedUser,
        setSelectedUser,
        isOpenModalReloadPage,
        setIsOpenModalReloadPage,
        setEditUserError,
        isEditMode,
        setIsEditMode,
        errorEditUser,
        setErrorEditUser,
        listB2CUserListInOrg,
        setListB2CUserListInOrg
    };

    useEffect(() => {
        props.setIsLoading(true);
        getListCustomerUserCanAddToProject(props?.API, corporationId, projectDetail)
            .then(async listCustomerCanAdd => {
                //filter users have fake mail
                listCustomerCanAdd = listCustomerCanAdd.filter(customer => !Utils.isFakePhoneUserEmail(customer?.mail));
                
                setCustomerListCanAdd(listCustomerCanAdd);
                updateSuggestCustomerUserList(listCustomerCanAdd, argsAll);

                let listCustomer = await getCustomerListInProjectByProjectId(
                    props?.API,
                    projectDetail.id
                );
                // Filter out users with fake phone email format
                const filteredListCustomer = listCustomer.map(
                    user => {
                        if(Utils.isFakePhoneUserEmail(user.mail)){
                            return {
                                ...user,
                                mail: '',
                                isEmailFromPhoneCall: true
                            };
                        }
                        return user;
                    }
                );
                setCustomerList(filteredListCustomer);

                props.setIsLoading(false);
                if (isAddNewUser) {
                    enqueueSnackbar(I18n.get('USER12MSG006'), {
                        variant: 'success',
                        autoHideDuration: 3000
                    });
                    setIsAddNewUser(false);
                }
            })
            .catch(error => {
                props.setIsLoading(false);
            });
    }, [triggerReload]);

    useEffect(() => {
        let isCancelTab = false;
        if (!Utils.isEmptyArray(userAddList)) {
            isCancelTab = true;
        }
        return props.parentCallBack(isCancelTab);
    }, [userAddList]);

    const submitCancelEdit = () => {
        onSubmitCancelEdit(argsAll);
    };

    const isDisplayBtnAddUser = () => {
        if (Utils.isPublicDesk(projectDetail)) {
            return true;
        }

        return false;
    };

    useEffect(() => {
        checkDisableBtnSubmit(argsAll);

        // update sugguestion list
        if (!Utils.isEmptyArray(defaultSuggestCustomerUserList)) {
            let currentDefaultSuggestCustomerUserList = cloneDeep(defaultSuggestCustomerUserList);
            let newSuggestCustomerUserList = currentDefaultSuggestCustomerUserList.filter(
                currentUserInfo => {
                    return !userAddList.some(
                        selectedUser => currentUserInfo.mail === selectedUser.mail
                    );
                }
            );
            setSuggestCustomerUserList(newSuggestCustomerUserList);
        }
    }, [userAddList, isEditMode, customerList, errorEditUser]);

    const renderStatusUser = (status, userInfo) => {
        switch (true) {
            case status === Constant.STATUS_OF_USER.WAITING &&
                userInfo.activeInProject === Constant.ACTIVE_FLAG.ACTIVE:
                return (
                    <div
                        className="status-user"
                        style={{ color: '#fff', backgroundColor: '#D09725' }}
                    >
                        Waiting
                    </div>
                );
            case userInfo.activeInProject === Constant.ACTIVE_FLAG.DELETED:
                return (
                    <div
                        className="status-user"
                        style={{ color: '#fff', backgroundColor: '#7f7f7f' }}
                    >
                        Deleted
                    </div>
                );
            case status === Constant.STATUS_OF_USER.REJECT:
                return (
                    <div
                        className="status-user"
                        style={{ color: '#fff', backgroundColor: '#DF6020' }}
                    >
                        Reject
                    </div>
                );
            case status === Constant.STATUS_OF_USER.ACTIVE &&
                userInfo.activeInProject === Constant.ACTIVE_FLAG.ACTIVE:
                return (
                    <div
                        className="status-user"
                        style={{ color: '#fff', backgroundColor: '#21BA87' }}
                    >
                        Active
                    </div>
                );
            case status === Constant.STATUS_OF_USER.DELETED:
                return (
                    <div
                        className="status-user"
                        style={{ color: '#fff', backgroundColor: '#7f7f7f' }}
                    >
                        Deleted
                    </div>
                );
            case status === Constant.STATUS_OF_USER.NOT_INVITED:
                return (
                    <div
                        className="status-user"
                        style={{ color: '#fff', backgroundColor: '#2D72D2' }}
                    >
                        {Constant.STATUS_OF_USER.NOT_INVITED}
                    </div>
                );
            default:
                break;
        }
    };

    const renderTblUserList = () => {
        return (
            <div className="table-tbl table-tbl--account">
                <Table style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell className="head-title-info">ユーザー情報</TableCell>
                            <TableCell align="left">ステータス</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!Utils.isEmptyArray(userAddList) &&
                            userAddList.map(user => (
                                <TableRow key={user.id}>
                                    <TableCell className="cell-group-info">
                                        <div className="cell-group-info-wrapper fixed-with-avatar">
                                            <img
                                                src="/assets/image/icon-user-default.svg"
                                                alt=""
                                                className="thumbAccount"
                                            />
                                            <div>
                                                <div className="group-name input-change">
                                                    <TextField
                                                        FormHelperTextProps={{
                                                            className: 'break-word-helper-text'
                                                        }}
                                                        className="form-control-wrapInput form-control-hg32 input-change-width"
                                                        variant="outlined"
                                                        placeholder="姓"
                                                        defaultValue={user.lastName}
                                                        value={user.lastName}
                                                        disabled={
                                                            user.isAutocomplete ? true : false
                                                        }
                                                        onChange={e =>
                                                            onChangeNameUser(
                                                                e,
                                                                user.id,
                                                                'lastName',
                                                                argsAll
                                                            )
                                                        }
                                                        error={
                                                            errors[user.id] &&
                                                            errors[user.id].lastName
                                                        }
                                                        helperText={
                                                            errors[user.id] &&
                                                            errors[user.id].lastName
                                                        }
                                                    />
                                                    <TextField
                                                        FormHelperTextProps={{
                                                            className: 'break-word-helper-text'
                                                        }}
                                                        className="form-control-wrapInput form-control-hg32 input-change-width"
                                                        variant="outlined"
                                                        placeholder="名"
                                                        defaultValue={user.firstName}
                                                        value={user.firstName}
                                                        disabled={
                                                            user.isAutocomplete ? true : false
                                                        }
                                                        onChange={e =>
                                                            onChangeNameUser(
                                                                e,
                                                                user.id,
                                                                'firstName',
                                                                argsAll
                                                            )
                                                        }
                                                        error={
                                                            errors[user.id] &&
                                                            errors[user.id].firstName
                                                        }
                                                        helperText={
                                                            errors[user.id] &&
                                                            errors[user.id].firstName
                                                        }
                                                    />
                                                </div>
                                                <div>
                                                    {!user.isAddNew && (
                                                        <TextField
                                                            className="form-control-wrapInput form-control-hg32 input-change"
                                                            variant="outlined"
                                                            placeholder="ユーザーID（メールアドレス)"
                                                            defaultValue={user.mail}
                                                            value={user.mail}
                                                            onChange={e =>
                                                                onChangeEmail(e, user.id, argsAll)
                                                            }
                                                            error={
                                                                errors[user.id] &&
                                                                errors[user.id].mail
                                                            }
                                                            helperText={
                                                                errors[user.id] &&
                                                                errors[user.id].mail
                                                            }
                                                        />
                                                    )}

                                                    {user.isAddNew && (
                                                        <Autocomplete
                                                            className="search-user input-change"
                                                            freeSolo
                                                            disableClearable
                                                            sx={{
                                                                maxHeight: 5
                                                            }}
                                                            options={suggestCustomerUserList}
                                                            getOptionLabel={option => {
                                                                return option.label || '';
                                                            }}
                                                            filterOptions={filterSugguestionOption}
                                                            renderOption={option => (
                                                                <Tooltip title={option.label}>
                                                                    <span
                                                                        style={{
                                                                            overflow: 'hidden',
                                                                            whiteSpace: 'nowrap',
                                                                            textOverflow: 'ellipsis'
                                                                        }}
                                                                    >
                                                                        {option.label}
                                                                    </span>
                                                                </Tooltip>
                                                            )}
                                                            onChange={(e, value) =>
                                                                onSelectSugguestUser(
                                                                    value,
                                                                    argsAll,
                                                                    user
                                                                )
                                                            }
                                                            inputValue={user.mail || ''}
                                                            renderInput={params => (
                                                                <TextField
                                                                    {...params}
                                                                    className="form-control-wrapInput form-control-hg32"
                                                                    defaultValue={user.mail || ''}
                                                                    value={user.mail || ''}
                                                                    onKeyPress={e =>
                                                                        onChangeEmail(
                                                                            e,
                                                                            user.id,
                                                                            argsAll
                                                                        )
                                                                    }
                                                                    placeholder="ユーザーID（メールアドレス)"
                                                                    onChange={e => {
                                                                        onChangeEmail(
                                                                            e,
                                                                            user.id,
                                                                            argsAll
                                                                        );
                                                                    }}
                                                                    onKeyDown={e => {
                                                                        if (e.key === 'Enter') {
                                                                            e.stopPropagation();
                                                                        }
                                                                    }}
                                                                    variant="outlined"
                                                                    error={
                                                                        errors[user.id] &&
                                                                        errors[user.id].mail
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    helperText={
                                                                        errors[user.id] &&
                                                                        errors[user.id].mail
                                                                    }
                                                                />
                                                            )}
                                                        />
                                                    )}
                                                </div>
                                                <div className="phone-input-container input-change">
                                                    <PhoneInput
                                                        country={'jp'}
                                                        value={user?.phoneNumber || ''}
                                                        onChange={phoneNumber =>
                                                            onChangePhoneNumber(
                                                                phoneNumber,
                                                                user?.id,
                                                                argsAll
                                                            )
                                                        }
                                                        placeholder="+81"
                                                        disabled={user?.isAutocomplete}
                                                        countryCodeEditable={true}
                                                        enableAreaCodes={true}
                                                        inputProps={{
                                                            name: `phoneNumber-${user?.id}`,
                                                            className: clsx('form-control', {
                                                                'error-border':
                                                                    errors[`${user?.id}`] &&
                                                                    errors[`${user?.id}`]
                                                                        ?.phoneNumber
                                                            })
                                                        }}
                                                        containerStyle={{
                                                            width: '100%'
                                                        }}
                                                        inputStyle={{
                                                            width: '100%',
                                                            height: '32px'
                                                        }}
                                                    />
                                                    {errors[user?.id] &&
                                                        errors[user?.id]?.phoneNumber && (
                                                            <div className="phone-input-error">
                                                                {errors[user?.id]?.phoneNumber}
                                                            </div>
                                                        )}
                                                </div>
                                                <div>
                                                    <TextField
                                                        FormHelperTextProps={{
                                                            className: 'break-word-helper-text'
                                                        }}
                                                        className="form-control-wrapInput form-control-hg32 input-change"
                                                        variant="outlined"
                                                        placeholder="組織（会社名）"
                                                        value={user?.organizationName || ''}
                                                        disabled={user?.isAutocomplete}
                                                        onChange={e =>
                                                            onChangeOrganizationName(
                                                                e,
                                                                user?.id,
                                                                argsAll
                                                            )
                                                        }
                                                        error={
                                                            errors[user?.id] &&
                                                            errors[user?.id].organizationName
                                                        }
                                                        helperText={
                                                            errors[user?.id] &&
                                                            errors[user?.id].organizationName
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </TableCell>
                                    <TableCell className="cell-group-btn table-row-top">
                                        <div className="action-group action-group-create">
                                            <div className="group-status d-none">
                                                <div className="status-user"></div>
                                            </div>
                                            <div className="groupBtn-action action-delete-add-user">
                                                <Button
                                                    className="btn-action"
                                                    onClick={() => {
                                                        isFillUserData(userAddList, user?.id)
                                                            ? setIsOpenDialogConfirmDelete({
                                                                  isEnable: true,
                                                                  userId: user?.id
                                                              })
                                                            : reMoveRowProjectUser(
                                                                  argsAll,
                                                                  user?.id,
                                                                  userAddList,
                                                                  setUserAddList
                                                              );
                                                    }}
                                                >
                                                    <img
                                                        src="/assets/image/delete-icon.svg"
                                                        alt=""
                                                    />
                                                </Button>
                                            </div>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                    <TableBody>
                        {!Utils.isEmptyArray(customerList) &&
                            customerList.map(user =>
                                isEditMode && user.isEditMode ? (
                                    <TableRow key={user.id}>
                                        <TableCell className="cell-group-info">
                                            <div className="cell-group-info-wrapper">
                                                <img
                                                    src={user.avatar}
                                                    alt=""
                                                    className="thumbAccount"
                                                />
                                                <div>
                                                    <div className="group-name">
                                                        <TextField
                                                            FormHelperTextProps={{
                                                                className: 'break-word-helper-text'
                                                            }}
                                                            className="form-control-wrapInput form-control-hg32 input-change-width"
                                                            variant="outlined"
                                                            placeholder="姓"
                                                            id={`lastName-${user?.id}`}
                                                            defaultValue={Utils.getTextByLanguage(
                                                                Constant.LANGUAGE_TYPE.JP,
                                                                user.lastName
                                                            )}
                                                            inputProps={{
                                                                minlength: 1,
                                                                maxlength: 200
                                                            }}
                                                            onChange={e =>
                                                                validateEditUser(
                                                                    e,
                                                                    user?.id,
                                                                    argsAll
                                                                )
                                                            }
                                                            error={
                                                                errorEditUser[`${user?.id}`] &&
                                                                errorEditUser[`${user?.id}`].lastName
                                                            }
                                                            helperText={
                                                                errorEditUser[`${user?.id}`] &&
                                                                errorEditUser[`${user?.id}`].lastName
                                                            }
                                                        />
                                                        <TextField
                                                            FormHelperTextProps={{
                                                                className: 'break-word-helper-text'
                                                            }}
                                                            className="form-control-wrapInput form-control-hg32 input-change-width"
                                                            variant="outlined"
                                                            placeholder="名"
                                                            id={`firstName-${user?.id}`}
                                                            defaultValue={Utils.getTextByLanguage(
                                                                Constant.LANGUAGE_TYPE.JP,
                                                                user.firstName
                                                            )}
                                                            inputProps={{
                                                                minlength: 1,
                                                                maxlength: 200
                                                            }}
                                                            onChange={e =>
                                                                validateEditUser(
                                                                    e,
                                                                    user?.id,
                                                                    argsAll
                                                                )
                                                            }
                                                            error={
                                                                errorEditUser[`${user?.id}`] &&
                                                                errorEditUser[`${user?.id}`].firstName
                                                            }
                                                            helperText={
                                                                errorEditUser[`${user?.id}`] &&
                                                                errorEditUser[`${user?.id}`].firstName
                                                            }
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            className="form-control-wrapInput form-control-hg32 input-change"
                                                            variant="outlined"
                                                            placeholder="ユーザーID（メールアドレス)"
                                                            id={`mailAddress-${user?.id}`}
                                                            defaultValue={Utils.getDisplayUserEmailWithoutSuffix(
                                                                user.mail
                                                            )}
                                                            value={user?.mailAddress || Utils.getDisplayUserEmailWithoutSuffix(
                                                                user.mail
                                                            )}
                                                            disabled={!user?.isEmailFromPhoneCall}
                                                            onChange={e =>
                                                                validateEditUser(
                                                                    e,
                                                                    user?.id,
                                                                    argsAll
                                                                )
                                                            }
                                                            error={
                                                                errorEditUser[`${user?.id}`] &&
                                                                errorEditUser[`${user?.id}`].email
                                                            }
                                                            helperText={
                                                                errorEditUser[`${user?.id}`] &&
                                                                errorEditUser[`${user?.id}`].email
                                                            }
                                                        />
                                                    </div>
                                                    <div className="phone-input-container">
                                                        <PhoneInput
                                                            country={'jp'}
                                                            value={user?.tel || ''}
                                                            disabled={true}
                                                            countryCodeEditable={false}
                                                            enableLongNumbers={true}
                                                            placeholder="+81"
                                                            inputProps={{
                                                                name: `phoneNumber-${user?.id}`,
                                                                className: 'form-control'
                                                            }}
                                                            containerStyle={{
                                                                width: '100%'
                                                            }}
                                                            inputStyle={{
                                                                width: '100%',
                                                                height: '32px'
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            FormHelperTextProps={{
                                                                className: 'break-word-helper-text'
                                                            }}
                                                            className="form-control-wrapInput form-control-hg32 input-change"
                                                            variant="outlined"
                                                            placeholder="組織（会社名）"
                                                            id={`organizationName-${user?.id}`}
                                                            value={user?.organizationName || ''}
                                                            onChange={e =>
                                                                validateEditUser(
                                                                    e,
                                                                    user?.id,
                                                                    argsAll
                                                                )
                                                            }
                                                            error={
                                                                errorEditUser[`${user?.id}`] &&
                                                                errorEditUser[`${user?.id}`].organizationName
                                                            }
                                                            helperText={
                                                                errorEditUser[`${user?.id}`] &&
                                                                errorEditUser[`${user?.id}`].organizationName
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell className="cell-group-btn table-row-top">
                                            <div className="action-group action-group-create">
                                                <div className="group-status">
                                                    {renderStatusUser(
                                                        Utils.getUserStatus(user),
                                                        user
                                                    )}
                                                </div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    <TableRow key={user?.id}>
                                        <TableCell className="cell-user-image">
                                            <div className="fixed-with-avatar">
                                                <img
                                                    src={user?.avatar}
                                                    alt=""
                                                    className="thumbAccount"
                                                />
                                            </div>
                                            <div>
                                                <OverFlowTooltip
                                                    value={Utils.getFullNameOfUser(
                                                        Constant.LANGUAGE_TYPE.JP,
                                                        user
                                                    )}
                                                />
                                                <div className="cell-user-mail">
                                                    {Utils.getDisplayUserEmailWithoutSuffix(
                                                        user?.mail
                                                    )}
                                                </div>
                                                {user?.tel && (
                                                    <div className="cell-user-tel">
                                                        <div className="phone-input-container">
                                                            <PhoneInput
                                                                country={'jp'}
                                                                value={user?.tel || ''}
                                                                disabled={true}
                                                                countryCodeEditable={false}
                                                                enableLongNumbers={true}
                                                                placeholder="+81"
                                                                inputProps={{
                                                                    name: `phoneNumber-display-${user?.id}`,
                                                                    className: 'form-control'
                                                                }}
                                                                containerStyle={{
                                                                    width: '100%'
                                                                }}
                                                                inputStyle={{
                                                                    width: '100%',
                                                                    height: '32px'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                                {user?.organizationName && (
                                                    <div className="cell-user-organization">
                                                        {user?.organizationName}
                                                    </div>
                                                )}
                                            </div>
                                        </TableCell>
                                        <TableCell className="cell-group-info">
                                            <div className="action-group">
                                                <div className="group-status">
                                                    {renderStatusUser(
                                                        Utils.getUserStatus(user),
                                                        user
                                                    )}
                                                </div>
                                                <div>
                                                    <div className="groupBtn-action">
                                                    {/* <Tooltip placement="top-start" title="block">
                                                        <Button className="btn-action disabled">
                                                            <img
                                                                src="/assets/image/icon-block.svg"
                                                                alt=""
                                                            />
                                                        </Button>
                                                    </Tooltip> */}
                                                    {isDisplayBtnRestoreB2C(argsAll, user) && (
                                                        <Button 
                                                            className="btn-action"
                                                            onClick={() =>
                                                                handleClickRestoreB2CInProject(
                                                                    argsAll,
                                                                    user
                                                                )
                                                            }
                                                            disabled={!projectDetail.isDesk}
                                                        >
                                                            <img
                                                                src="/assets/image/icon-restore.svg"
                                                                alt=""
                                                            />
                                                        </Button>
                                                    )}
                                                    {!isDisableBtnEditB2C(argsAll, user) && (
                                                        <Button
                                                            className="btn-action"
                                                            onClick={() => handleEdit(user, argsAll)}
                                                            disabled={!projectDetail.isDesk}
                                                        >
                                                            <img
                                                                src="/assets/image/edit-icon.svg"
                                                                alt=""
                                                            />
                                                        </Button>
                                                    )}
                                                    {!isDisableBtnDeleteProjectB2C(argsAll, user) &&(
                                                        <Button
                                                            className="btn-action"
                                                            disabled={!projectDetail.isDesk}
                                                            onClick={() =>
                                                                onClickDeleteProjectB2C(
                                                                    argsAll,
                                                                    user
                                                                )
                                                            }
                                                        >
                                                            <img
                                                                src="/assets/image/delete-icon.svg"
                                                                alt=""
                                                            />
                                                        </Button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </TableCell>
                                </TableRow>
                                )
                            )}
                    </TableBody>
                </Table>
                {isOpenDialogConfirmDelete.isEnable && (
                    <ConfirmDeleteAdditionUserDialog
                        argsAll={argsAll}
                        parentScreen={Constant.SCREEN_LIST.B2C_IN_PROJECT}
                    />
                )}
                {isOpenModalRejectDeleteUser && (
                    <RejectDeleteCustomerUser
                        argsAll={argsAll}
                        isOpen={isOpenModalRejectDeleteUser}
                        setIsOpen={setIsOpenModalRejectDeleteUser}
                    />
                )}
            </div>
        );
    };

    return (
        <>
            <div className="groupUser" data-cy="project-user-list">
                {/* {isProjectManager && ( */}
                <div className="head-wrap">
                    <div className="head-btn head-change">
                        <div className="head-btn-add">
                            {isDisplayBtnAddUser() && (
                                <Button
                                    className="btn-add-project"
                                    onClick={() =>
                                        addNewRowProjectUser(userAddList, setUserAddList)
                                    }
                                >
                                    <div className="btn-plus-icon">
                                        <img src="/assets/image/icon-plus-add.svg" alt="" />
                                    </div>
                                    <div className="btn-text-add">
                                        {I18n.get('USER03BTN005')}
                                    </div>
                                </Button>
                            )}
                        </div>

                        <div className="head-btn-wrap">
                            <div className="btn-cancel">
                                {(isEditMode || !Utils.isEmptyArray(userAddList)) && (
                                    <Button
                                        className="btn-light btn-hg32"
                                        variant="contained"
                                        color="primary"
                                        disabled={!(!Utils.isEmptyArray(userAddList) || isEditMode)}
                                        onClick={() => onClickCancelEdit(argsAll)}
                                    >
                                        {I18n.get('COMBTN001')}
                                    </Button>
                                )}
                            </div>
                            <div className="btn-submit">
                                {(isEditMode || !Utils.isEmptyArray(userAddList)) && (
                                    <Button
                                        className="btn-primary btn-hg32"
                                        variant="contained"
                                        color="primary"
                                        disabled={isDisableBtnSubmit}
                                        onClick={() => handleSubmit(argsAll)}
                                    >
                                        {I18n.get('COMBTN011')}
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="projectUser-table customer-project"
                    data-cy="project-users-table-list"
                >
                    {renderTblUserList()}
                </div>

                <CancelEditCustomerList
                    {...argsAll}
                    isOpen={isOpenModalConfirmCancel}
                    setIsOpen={setIsOpenModalConfirmCancel}
                    submitAction={submitCancelEdit}
                />

                <ConfirmRestoreUser 
                    isOpen={isOpenDialogConfirmRestoreUser}
                    setIsOpen={setIsOpenDialogConfirmRestoreUser}
                    submitAction={() => onSubmitRestoreB2CInProject(argsAll)}
                />

                <DataChangePleaseReloadModal {...argsAll} isOpen={isOpenModalReloadPage} setIsOpen={setIsOpenModalReloadPage} />
                <ConfirmDialog 
                    isOpen={!Utils.isEmptyString(editUserError)} 
                    okCallBack={() => {setEditUserError('')}} 
                    msgConfirm={editUserError}
                    textSubmit={I18n.get('COMBTN006')}
                />
            </div>
        </>
    );
}
